import _ from '@/assets/lib/my-lodash'
import { fetchBlobUrlAsBase64 } from '@/mixins/blob-utils'
import { emitter } from '@/plugins/emitter'
const SAVE_KEY_PREFIX = 'format_'
const SAVE_INTERVAL_MS = 1000

// 動作確認用デバッグ: ページ初期ロード時点の ?rtWaitDebug=<ms> をモジュールスコープに保持する。
// FormatEdit は mounted 直後に closePreview() が query なしで $router.push するため、
// getItem コールバック実行時には location.search が既に空になっている。
const RT_WAIT_DEBUG_MS = Number(
  new URLSearchParams(window.location.search).get('rtWaitDebug')
)

export default {
  data: function () {
    return {
      saveName: '',
      saveOtherName: '',
      saveKeyPrefix: SAVE_KEY_PREFIX,
      dataChangedEmitKey: 'format-data-changed',
      otherDataChangedEmitKey: 'format-otherdata-changed',
      formatData: {},
      otherFormatData: {},
      isNowSaving: false,
      changeCount: 0
    }
  },
  computed: {
    saveKey: function () {
      if (!this.saveName) {
        return
      }
      return this.saveKeyPrefix + this.saveName
    },
    saveOtherKey: function () {
      if (!this.saveOtherName) {
        return
      }
      return this.saveKeyPrefix + this.saveOtherName
    }
  },
  methods: {
    saveFormatData: _.debounce(
      function () {
        const app = this
        if (!this.saveKey) {
          return
        }

        // blob URLはセッション限りなので、保存時にbase64に戻す
        if (
          this.formatData.idPhotoSrc &&
          this.formatData.idPhotoSrc.startsWith('blob:')
        ) {
          const dataToSave = Object.assign({}, this.formatData)
          fetchBlobUrlAsBase64(this.formatData.idPhotoSrc)
            .then(function (base64) {
              dataToSave.idPhotoSrc = base64
              app.$setItem(app.saveKey, dataToSave, function (err) {
                app.isNowSaving = false
                if (!err) {
                  app.$eventHub.$emit('save-complete-notify', 'おぼえた')
                  emitter.emit('save-complete-notify', 'おぼえた')
                  emitter.emit('yagi-message', { text: 'おぼえた' })
                }
              })
            })
            .catch(function (e) {
              console.warn('[local-data-mixin] blob URL→base64変換失敗:', e)
              app.isNowSaving = false
            })
          return
        }

        this.$setItem(this.saveKey, this.formatData, function (err) {
          if (err) {
            // console.log(err)
            app.isNowSaving = false
            return
          }
          // console.log('saved:', app.formatData)
          app.isNowSaving = false
          app.$eventHub.$emit('save-complete-notify', 'おぼえた')
          emitter.emit('save-complete-notify', 'おぼえた')
          emitter.emit('yagi-message', { text: 'おぼえた' })
        })
      },
      // ユーザーの入力が終わるのを待つ時間をミリ秒で指定します。
      SAVE_INTERVAL_MS
    ),
    loadFormatData: function () {
      const app = this
      const applyLoadedData = function (err, data) {
        if (err) {
          console.log(err)
          // 保存データの有無・成否に関わらずロード試行完了を通知する
          // （FormatEdit が basicData の読込完了を待って getDisableRtCondition を
          //   fetch するために使用。'local-format-data-loaded' はデータありの時
          //   しか発火しないため別イベントにしている）
          app.$eventHub.$emit('local-format-data-load-finished', app.saveName)
          emitter.emit('local-format-data-load-finished', app.saveName)
          return
        }
        if (data == null || typeof data === 'undefined') {
          app.$eventHub.$emit('local-format-data-load-finished', app.saveName)
          emitter.emit('local-format-data-load-finished', app.saveName)
          return
        }
        app.formatData = data
        // 読み込み完了後にプレビューの高さ計算する用
        app.$nextTick(() => {
          app.$eventHub.$emit('local-format-data-loaded', app.saveName)
          emitter.emit('local-format-data-loaded', app.saveName)
          // $nextTick 内で発火することで、formatData 代入の deep watcher
          // （basic-data-changed → 親の basicData 反映）より後になることを保証する
          app.$eventHub.$emit('local-format-data-load-finished', app.saveName)
          emitter.emit('local-format-data-load-finished', app.saveName)
        })
        // 読み込み直後の再保存を防ぐ
        app.changeCount = 0
      }
      this.$getItem(this.saveKey, function (err, data) {
        // 動作確認用デバッグフック: ?rtWaitDebug=3000 を付けると basicData の
        // 読込完了処理自体を遅延させ、FormatEdit のオーバーレイ spinner を確認できる。
        // クエリなしの通常アクセスでは即時処理で挙動は変わらない。
        const debugDelayMs = app.saveKey === 'basicData' ? RT_WAIT_DEBUG_MS : 0
        if (Number.isFinite(debugDelayMs) && debugDelayMs > 0) {
          setTimeout(function () {
            applyLoadedData(err, data)
          }, debugDelayMs)
          return
        }
        applyLoadedData(err, data)
      })
    },
    loadOtherFormatData: function () {
      const app = this
      this.$getItem(this.saveOtherKey, function (err, data) {
        if (err) {
          console.log(err)
          return
        }
        if (data == null || typeof data === 'undefined') {
          return
        }
        app.otherFormatData = data
      })
    },
    updateFormatData: function (newData) {
      for (const nd in newData) {
        if (Object.prototype.hasOwnProperty.call(this.formatData, nd)) {
          this.$set(this.formatData, nd, newData[nd])
        } else {
          console.log('not hasOwnProperty:', nd)
        }
      }
    },
    setDefaultFormatData: function () {}
  },
  watch: {
    formatData: {
      deep: true,
      handler: function (val) {
        for (const rval in val) {
          const _tval = val[rval]
          if (typeof _tval === 'string' || _tval instanceof String) {
            // console.error(_tval)
            val[rval] = _tval.replace('\u0000', '')
          }
        }
        this.$eventHub.$emit(this.dataChangedEmitKey, val)
        emitter.emit(this.dataChangedEmitKey, val)
        this.changeCount++
      },
      immediate: false
    },
    otherFormatData: {
      deep: true,
      handler: function (val) {
        this.$eventHub.$emit(this.otherDataChangedEmitKey, val)
      },
      immediate: false
    },
    changeCount: function () {
      if (!this.$yagi.profile.autoSaveEnabled) {
        console.log(
          'saveFormatData() skipped autoSaveEnabled is false',
          this.$yagi.profile.autoSaveEnabled
        )
        return
      }
      /* 初回ロード完了時に保存が走ってしまうのでスキップ */
      if (this.changeCount < 2) {
        return
      }
      if (!this.isNowSaving) {
        this.saveFormatData()
      } else {
        console.log('skip saveFormatData', this.isNowSaving)
      }
    }
  },
  beforeMount: function () {
    this.setDefaultFormatData()
    this.loadFormatData()
    this.loadOtherFormatData()
    emitter.on('backup-loaded-' + this.saveKey, this.loadFormatData)
  },
  destroyed: function () {
    emitter.off('backup-loaded-' + this.saveKey)
  }
}
